import { TranslateService } from '@ngx-translate/core';
import NetworkError from '@shared/errors/network-error';
import CreateComponentCO2Model from './create-component-co2-model';
import CreateComponentCO2LinkModel from './create-component-co2link-model';
import DeleteComponentCO2Model from './delete-component-co2-model';
import DeleteComponentCO2LinkModel from './delete-component-co2link-model';
import EditComponentCO2Model from './edit-component-co2-model';
import FilterComponentCO2Model from './filter-component-co2-model';
import FilterComponentCO2LinkModel from './filter-component-co2link.model';
import ImportCSVModel from './import-csv-model';
import ListComponentCO2Model from './list-component-co2-model';
import ListComponentCO2LinkModel from './list-component-co2link-model';
import PhasesCO2Model from './phases-co2-model';
import SearchCO2LinkModel from './search-co2link.model';

/** The CO2Model is responsible for instantiation of the child models and hold a reference to them as public properties we can hook into from the view. */
export default class CO2Model {
	public namePattern: string;
	public createComponentCO2Model: CreateComponentCO2Model;
	public editComponentCO2Model: EditComponentCO2Model;
	public filterComponentCO2Model: FilterComponentCO2Model;
	public listComponentCO2Model: ListComponentCO2Model;
	public phasesCO2Model: PhasesCO2Model;
	public deleteComponentCO2Model: DeleteComponentCO2Model;
	public listComponentCO2LinkModel: ListComponentCO2LinkModel;
	public createComponentCO2LinkModel: CreateComponentCO2LinkModel;
	public deleteComponentCO2LinkModel: DeleteComponentCO2LinkModel;
	public filterComponentCO2LinkModel: FilterComponentCO2LinkModel;
	public searchCO2LinkModel: SearchCO2LinkModel;
	public importCSVModel: ImportCSVModel;
	public globalErrorDialog: HTMLDialogElement | null;
	public networkErrorLabelVisible: boolean;
	public unknownErrorLabelVisible: boolean;
	public constructor(translateService: TranslateService) {
		// RegExp that accepts [a-zA-Z0-9-]
		this.namePattern = '^[a-zA-Z0-9\\-]+$';
		this.createComponentCO2Model = new CreateComponentCO2Model();
		this.editComponentCO2Model = new EditComponentCO2Model();
		this.listComponentCO2Model = new ListComponentCO2Model();
		this.phasesCO2Model = new PhasesCO2Model(translateService);
		this.filterComponentCO2Model = new FilterComponentCO2Model(this);
		this.deleteComponentCO2Model = new DeleteComponentCO2Model();
		this.listComponentCO2LinkModel = new ListComponentCO2LinkModel();
		this.createComponentCO2LinkModel = new CreateComponentCO2LinkModel();
		this.deleteComponentCO2LinkModel = new DeleteComponentCO2LinkModel();
		this.filterComponentCO2LinkModel = new FilterComponentCO2LinkModel(this);
		this.importCSVModel = new ImportCSVModel();
		this.searchCO2LinkModel = new SearchCO2LinkModel();
		this.globalErrorDialog = null;
		this.networkErrorLabelVisible = false;
		this.unknownErrorLabelVisible = false;
	}

	public closeGlobalErrorDialog(): void {
		if (this.globalErrorDialog) {
			this.globalErrorDialog.close();
		}
	}

	public showGlobalErrorDialog(error: NetworkError): void {
		if (this.globalErrorDialog) {
			this.networkErrorLabelVisible = error instanceof NetworkError;
			this.unknownErrorLabelVisible = !(error instanceof NetworkError);
			this.globalErrorDialog.showModal();
		}
	}
}
